import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'

interface LoaderProps {
  text?: string
}

const Loader = (props: LoaderProps) => {
  const loaderText = props.text || 'Loading'
  return (
    <div className="loader-container w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <FontAwesomeIcon icon={faSpinner} className="text-5xl loader-spinner" />
        <span className="text-center text-xs mt-4">{loaderText}</span>
      </div>
    </div>
  )
}

export default Loader
